import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

interface ToastMessage {
  severity: 'info' | 'success' | 'warn' | 'error';
  summary: string;
  detail?: string;
  key: string;
  life: number;
  sticky: boolean;
}

export const TOAST_KEY = 'centraltoast';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly toastMessageObs$ = new Subject<ToastMessage>();

  constructor() {}

  getToastMessageObs(): Observable<ToastMessage> {
    return this.toastMessageObs$.asObservable();
  }

  showInformationMessage(summary: string, detail: string | null = null): void {
    this.show('info', summary, detail, 5000);
  }

  showSuccessMessage(summary: string, detail: string | null = null): void {
    this.show('success', summary, detail, 4000);
  }

  showWarningMessage(summary: string, detail: string | null = null): void {
    this.show('warn', summary, detail, 8000);
  }

  showErrorMessage(summary: string, detail: string | null = null): void {
    this.show('error', summary, detail, 0, true);
  }

  private show(
    severity: ToastMessage['severity'],
    summary: string,
    detail: string | null,
    life: number,
    sticky = false,
  ): void {
    this.toastMessageObs$.next({ severity, summary, detail: detail ?? undefined, key: TOAST_KEY, life, sticky });
  }
}
